import { createSlice } from '@reduxjs/toolkit';
import { IMdbError } from '../../../errorObjects/MdbError';

// export interface ISaveCategoryFailureState {
//   value: IMdbError | null
// }

const initialState: IMdbError | null = null;

export const categorySaveFailureSlice = createSlice({
  name: 'categorySaveFailure',
  initialState,
  reducers: {
    // action has a payload with an error
    categorySaveFailureChange(state, action) {
      return action.payload;
    },
        
    // action has a payload with a null value
    categorySaveFailureClear(state, action) {
      return null; // action.payload;
    },
  },
})

// Action creators are generated for each function in reducer)
export const { categorySaveFailureChange, categorySaveFailureClear } = categorySaveFailureSlice.actions;

// export the core reducer for the slice
export const categorySaveFailureReducer = categorySaveFailureSlice.reducer;

export default categorySaveFailureSlice.reducer;